// src/EmissionsSubsection.jsx

import React, { useState, useEffect, useRef } from 'react';

export default function EmissionsSubsection({
  initialData = [],
  onDataChange,
  isEditMode = false,
}) {
  const [items, setItems] = useState(initialData);

  // Ref to skip the very first notification after syncing props → state
  const skipNextNotify = useRef(false);

  // 1️⃣ Sync incoming initialData into local state, but only when it truly differs
  useEffect(() => {
    const prev = JSON.stringify(items);
    const next = JSON.stringify(initialData);
    if (prev !== next) {
      setItems(initialData);
      skipNextNotify.current = true;
    }
  }, [initialData]);

  // 2️⃣ Notify parent when items change (but skip once immediately after sync)
  useEffect(() => {
    if (skipNextNotify.current) {
      skipNextNotify.current = false;
      return;
    }
    // Only notify if items really differ
    if (JSON.stringify(items) !== JSON.stringify(initialData)) {
      onDataChange(items);
    }
  }, [items, initialData, onDataChange]);

  const add = () =>
    setItems(prev => [...prev, { type: '', value: '' }]);
  const remove = idx =>
    setItems(prev => prev.filter((_, i) => i !== idx));
  const handle = (idx, field, value) =>
    setItems(prev => {
      const copy = [...prev];
      copy[idx] = { ...copy[idx], [field]: value };
      return copy;
    });

  return (
    <div className="mb-4">
      <h5 className="fw-bold">Emissions</h5>

      {items.map((em, idx) => (
        <div key={idx} className="border p-3 mb-3">
          <h6>Emission {idx + 1}</h6>
          <div className="row g-2">
            <div className="col-md-5">
              <label className="form-label">Type</label>
              <input
                type="text"
                className="form-control"
                value={em.type || ''}
                onChange={e => handle(idx, 'type', e.target.value)}
              />
            </div>
            <div className="col-md-5">
              <label className="form-label">Value (g/kWh)</label>
              <input
                type="number"
                className="form-control"
                value={em.value || ''}
                onChange={e => handle(idx, 'value', e.target.value)}
              />
            </div>
            {!isEditMode && (
              <div className="col-md-1 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => remove(idx)}
                >
                  &times;
                </button>
              </div>
            )}
          </div>
        </div>
      ))}

      {!isEditMode && (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={add}
        >
          + Add Emission
        </button>
      )}
    </div>
  );
}
